import { LoaderCircle } from 'lucide-react';
import type { VariantProps } from 'class-variance-authority';
import type { ComponentProps, FC } from 'react';

import { cn } from '@/lib/utils';

import { spinnerVariants } from './spinner-variants';

export interface SpinnerProps
  extends Omit<ComponentProps<typeof LoaderCircle>, 'ref' | 'size'>,
    VariantProps<typeof spinnerVariants> {
  /** Accessible name announced by screen readers. */
  label?: string;
}

export const Spinner: FC<SpinnerProps> = ({
  size,
  tone,
  className,
  label = 'Loading',
  ...props
}) => {
  // When the caller marks the icon decorative (e.g. inside <Loading />, which owns the live
  // region), drop the role and name so screen readers do not announce it twice.
  const isDecorative = props['aria-hidden'] === true || props['aria-hidden'] === 'true';

  return (
    <LoaderCircle
      role={isDecorative ? undefined : 'status'}
      aria-label={isDecorative ? undefined : label}
      data-slot="spinner"
      data-testid="spinner"
      className={cn(spinnerVariants({ size, tone }), className)}
      {...props}
    />
  );
};
